import styled from 'styled-components';

export const Container = styled.div`
  margin: 20px 8px;
  box-shadow: 0px 3px 10px -5px rgba(0, 0, 0, 0.25);
  position: relative;
  background: #fff;
  border-radius: 16px;

  @media (min-width: 1024px) {
    margin: 20px 0 0 0;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
  }
`;

export const ContentWrapper = styled.div`
  background: #fff;
  overflow: hidden;
  transition: max-height 0.5s 0s ease-in-out;
  border-radius: 0 0 16px 16px;
`;

export const Content = styled.div`
  padding: 16px;

  @media (min-width: 1024px) {
    padding: 24px 16px;
  }
`;
